import { isLockedToLegacy } from "../../../lib/enum/project-phase.mjs"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"

export function DeleteMenuItem({ handleDelete, ...props }) {
    const { targetId, project } = useBoundContext()
    return (
        <ContextMenuItem
            data-cy="delete-menu-item"
            icon="gravity-ui:trash-bin"
            label="Delete"
            onClick={() => handleDelete([targetId])}
            disabled={isLockedToLegacy(project?.phase)}
            {...props}
        />
    )
}
